import {Tooltip as PepsicoDsTooltip} from 'pepsico-ds'

/**
 * Tooltip component that renders a PepsicoDsTooltip with properties from props.
 *
 * @param {Object} props - The properties object.
 * @param {string} props.text - The text to display in the tooltip.
 * @param {ReactNode} props.children - The content to wrap with the tooltip.
 * @param {string} [props.className=''] - Optional additional CSS class names to apply to the tooltip.
 * @param {("left" | "right" | "top-left" | "top-middle" | "top-right" | "bottom-left" | "bottom-middle" | "bottom-right")} [props.direction='bottom-middle'] - The direction of the tooltip.
 * @param {string} [props.id=''] - Optional additional id to apply to the tooltip.
 * @param {boolean} [props.isDark=true] - Optional flag to indicate if the tooltip should use dark theme.
 * @returns {JSX.Element} The rendered PepsicoDsTooltip component.
 */
const Tooltip = ({text, children, className = '', direction = 'bottom-middle', id = '', isDark = true}) => {
  return (
    <PepsicoDsTooltip
      data-testid={`tooltip` + (id ? `_${id}` : '')}
      id={`tooltip` + (id ? `_${id}` : '')}
      text={text}
      className={`custom-tooltip ${className}`}
      direction={direction}
      isDark={isDark}
    >
      {children}
    </PepsicoDsTooltip>
  )
}

export default Tooltip
